<!--
   Created by qing on 2022/3/19 下午5:45
   Des:
-->
<template>
  <div class="view-share-page" v-if="!loading">
    <div
      v-if="!errorInfo"
      class="view-share-container">
      <router-view v-if="shareItem.shareConfig.needPwd === 'NO' || complete"></router-view>
      <div
        v-else
        class="link-query__password">
        <div class="link-posting__password-container">
          <div class="header">
            {{shareItem.viewInfo.viewName}}
          </div>
          <div class="password-container">
            <van-field
              v-model.trim="password"
              placeholder="请输入密码">
            </van-field>
            <van-button
              type="primary"
              block
              @click="verify">
              确定
            </van-button>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="error-page">
      <img :src="`${$BASE_PATH}/fetch/image?id=358184796255420417.png`" alt="">
      <p>{{errorInfo.info}}({{errorInfo.status}})</p>
    </div>
  </div>
</template>

<script>
  import {SUCCESS} from "../../../store/types";

  export default {
    name: "index",
    provide() {
      return {
        shareItem: this.shareItem
      }
    },
    data() {
      return {
        loading: true,
        errorInfo: null,
        shareItem: {},
        complete: false,
        password: ''
      }
    },
    async created() {

      const loading = this.$toast.loading()
      await this.$store.dispatch('actionFormViewShareOutGet', {shareId: this.$route.params.shareId})
        .then(({status, resultObject, info}) => {
          if (status === SUCCESS) {
            Object.keys(resultObject).forEach(key => {
              this.$set(this.shareItem, key, resultObject[key])
            })
            console.log('shareItem21111---', this.shareItem)
          } else {
            this.errorInfo = {
              status,
              info
            }
          }
        })
        .catch(console.error)
        .finally(() => {
          loading.clear()
          this.loading = false
        })
    },
    methods: {

      // 验证
      verify() {
        const loading = this.$toast.loading()
        this.$store.dispatch('actionFormViewShareOutPwdCheck', {
          shareId: this.$route.params.shareId,
          password: this.password
        }).then(({status, resultObject, info}) => {
          if (status === SUCCESS) {
            console.log('actionFormViewShareOutPwdCheck', {status, resultObject, info})
            if (resultObject.pwdRight === 'YES') {
              this.complete = true
            } else {
              this.$toast.fail('密码错误')
            }
          } else {
            this.$toast.fail(info)
          }
        }).finally(() => {
          loading.clear()
        }).catch(err => {
          console.error(err)
        })
      },
    },
  }
</script>

<style lang="less">

  .view-share-page {
    height: calc(100% - env(safe-area-inset-bottom));
    overflow: hidden;

    .view-share-container {
      height: 100%;

      .link-query__password {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .link-posting__password-container {
          margin: 0 20px;
          width: 100%;

          .header {
            width: 100%;
            height: 44px;
            background-color: #D9D9D9;
            color: #fff;
            text-align: center;
            padding: 12px;
          }

          .password-container {
            background-color: #fff;
            padding: 20px;
          }
        }
      }
    }
  }
</style>